<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="requests"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
      }"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td class="text-left">{{formatDate(item.created_at)}}</td>
            <td class="text-left">
              <a
                dark
                class="white--text"
                :href="`${url}/${item.request_uuid}`"
                target="_blank"
              >
                <v-icon>camera_alt</v-icon>
              </a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      headers: [
        { text: 'Pictures taken on', value: 'created_at' },
        { text: 'View', sortable: false }
      ]
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format(`ddd, MMM DD - YYYY @ hh:mm a`)
    }
  },
  computed: {
    ...mapGetters({
      requests: 'signage/requestsByDevice'
    }),

    url () {
      if (process.env.NODE_ENV === 'production') {
        return 'https://smart-racks-preview.unoapp.io'
      }
      if (process.env.NODE_ENV === 'uat') {
        return 'https://smart-racks-preview.uat.unoapp.io'
      }
      if (process.env.NODE_ENV === 'development') {
        return 'https://smart-racks-preview.dev.unoapp.io'
      }
      return 'https://smart-racks-preview.unoapp.io'
    }
  }
}
</script>

<style>
</style>
